module.exports = __webpack_public_path__ + "img/symbol_5.cb45b780.png";